import { IOnInit } from "angular";
import { RecordDataSource } from "../../../../../../../../records/grids";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../../../../records/grids/settings/gridSettingsService";
import { ColDef } from "../../../../../../../../records/grids/columns/colDef";
import { IQuery } from "../../../../../../../../records/server/query";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../../../../records/views/recordGridView";

import { vsObjectName as gamingContractMachineName } from "../../../../../configs/gamingContractMachine";
import { vsObjectName as machineName } from "../../../../../../configs/machine";
import { Record } from "../../../../../../../../records/server/crud";

export class GamingContractDetailMachineComponentController implements IOnInit {
  static $inject = [RecordGridViewServiceName, GridSettingsServiceName];

  /* bindings */
  defaultQuery?: IQuery;
  /* bindings */

  gridDataSource?: RecordDataSource;
  gridSettings?: IGridSettings;
  columns?: ColDef[];
  defaultSort?: string;
  nameSingular?: string;
  namePlural?: string;

  constructor(
    private readonly recordGridViewService: RecordGridViewService,
    private readonly gridSettingsService: GridSettingsService
  ) {}

  $onInit() {
    const gridConfiguration = this.recordGridViewService.getGridConfiguration(
      gamingContractMachineName
    )!;
    const machineConfiguration =
      this.recordGridViewService.getGridConfiguration(machineName)!;

    this.gridDataSource = gridConfiguration.gridDataSource;
    this.gridSettings = this.gridSettingsService.getGridSettings(
      Symbol("gamingContract.machines")
    );
    this.columns = machineConfiguration.columns;
    this.defaultSort = gridConfiguration.defaultSort;
    this.nameSingular = gridConfiguration.nameSingular;
    this.namePlural = gridConfiguration.namePlural;
  }
}
